var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-topup",
      "centered": "",
      "title": "Add Top-Up",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "md"
    },
    on: {
      "hidden": _vm.resetModal
    }
  }, [_c('validation-observer', {
    ref: "topupValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Amount",
      "label-for": "amount"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Amount",
      "vid": "amount",
      "rules": "required|numeric|min:0.01"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "amount",
            "type": "number",
            "step": "0.01",
            "state": errors.length > 0 ? false : null,
            "placeholder": "0.00"
          },
          on: {
            "input": _vm.calculatePerPostCost
          },
          model: {
            value: _vm.topupAmount,
            callback: function callback($$v) {
              _vm.topupAmount = $$v;
            },
            expression: "topupAmount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Currency",
      "label-for": "currency"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Currency",
      "vid": "currency_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          attrs: {
            "id": "currency",
            "options": _vm.filteredCurrencyOptions,
            "reduce": function reduce(item) {
              return item.id;
            },
            "label": "currency",
            "placeholder": "Select Currency"
          },
          on: {
            "input": _vm.calculatePerPostCost
          },
          model: {
            value: _vm.selectedCurrency,
            callback: function callback($$v) {
              _vm.selectedCurrency = $$v;
            },
            expression: "selectedCurrency"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Posts Added",
      "label-for": "posts_added"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Posts Added",
      "vid": "posts_added",
      "rules": "required|integer|min:1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "posts_added",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "0"
          },
          on: {
            "input": _vm.calculatePerPostCost
          },
          model: {
            value: _vm.topupPosts,
            callback: function callback($$v) {
              _vm.topupPosts = $$v;
            },
            expression: "topupPosts"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Top Up Date",
      "label-for": "topup_date"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "id": "topup_date",
      "max": _vm.todayDateString,
      "locale": "en-US",
      "placeholder": "Select Date",
      "today-button": "",
      "close-button": "",
      "reset-button": ""
    },
    model: {
      value: _vm.topupDate,
      callback: function callback($$v) {
        _vm.topupDate = $$v;
      },
      expression: "topupDate"
    }
  })], 1), _vm.calculatedCost > 0 ? _c('b-form-group', {
    attrs: {
      "label": "Per Post Cost (Preview)"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.currencySymbol + _vm.calculatedCost,
      "disabled": ""
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Attachment",
      "label-for": "attachment"
    }
  }, [_c('b-form-file', {
    attrs: {
      "id": "attachment",
      "multiple": "",
      "placeholder": "Choose files or drop here...",
      "drop-placeholder": "Drop files here...",
      "accept": "image/*,.pdf,.doc,.docx,.xls,.xlsx"
    },
    model: {
      value: _vm.attachmentFiles,
      callback: function callback($$v) {
        _vm.attachmentFiles = $$v;
      },
      expression: "attachmentFiles"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Note",
      "label-for": "note"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "note",
      "placeholder": "Optional note",
      "rows": "2"
    },
    model: {
      value: _vm.topupNote,
      callback: function callback($$v) {
        _vm.topupNote = $$v;
      },
      expression: "topupNote"
    }
  })], 1), _vm.isSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }